/* eslint-disable max-len */
export default {
    en: {
        page: {
            titleAutoMergeEnabled: 'Auto-merge <span class="text-success">enabled</span> by user:',
            titleAutoMergeDisabled: 'Auto-merge <span class="text-danger">disabled</span>',
            autoMergeTitle: 'Auto-merge',
            autoMergeDisable: 'Cancel',
            autoMergeEnable: 'Set to auto-merge'
        }
    },
    ru: {
        page: {
            titleAutoMergeEnabled: 'Автоматические слияние <span class="text-success">включено</span> пользователем:',
            titleAutoMergeDisabled: 'Автоматические слияние <span class="text-danger">отключено</span>',
            autoMergeTitle: 'Автоматические слияние',
            autoMergeDisable: 'Отменить',
            autoMergeEnable: 'Включить авто-слияние'
        }
    }
}